import { useDispatch, useSelector } from "react-redux";
import { ReactComponent as PlusIcon } from "icons/plus-in-circle.svg";
import { addNewTerm } from "slices/settings/slices/discoveryIgnoreSlice";
import PropTypes from "prop-types";
import { selectDiscoveryIgnore } from "slices/settings/selectors";

const SubHeader = ({ selectedRowIndex }) => {
  const dispatch = useDispatch();
  const { updatedBy, lastUpdated, editMode } = useSelector(
    selectDiscoveryIgnore
  );

  return (
    <div
      className="discovery_ignore_list__subheader"
      data-testid="discovery_ignore_list__subheader"
    >
      {updatedBy && lastUpdated ? (
        <p>
          Last updated by {updatedBy} on {lastUpdated}
        </p>
      ) : (
        <p>Last update by System</p>
      )}
      <div>
        <p>
          This is a list of words and phrases that we will ignore when running
          discovery.
        </p>
        {editMode && (
          <button
            type="button"
            onClick={() => {
              dispatch(addNewTerm(selectedRowIndex));
            }}
          >
            <span>
              <PlusIcon />
            </span>
            <span>New Term</span>
          </button>
        )}
      </div>
    </div>
  );
};

export default SubHeader;

SubHeader.propTypes = {
  selectedRowIndex: PropTypes.number.isRequired,
};
